// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_77-3";
export var contentContainer = "_77-0";
export var editorContainer = "_77-1";
export var quillInputForm = "_77-2";
export var zoneDivider = "_77-4";